module.exports = __webpack_public_path__ + "media/images/icons/bell-109edf016392f5ad372ecd0f88a64dd3.svg";